import React from 'react'

const BuyAds = () => {
  return (
    <div style={{marginTop:"80px"}}>BuyAds</div>
  )
}

export default BuyAds